<template>
  <bid-open-center
    :project-id="projectId"
    :project-info="projectInfo"
    :theme="theme"
  >
    <template v-slot:body>
      <template v-if="showFirstReviewPassTable && isDouble && !isQuotationFile">
        <div class="end-step-table" :class="{ light: theme === 'light' }">
          <div class="end-step-table-title">
            一阶段评审通过名单({{ total }}家)
          </div>
          <el-table
            :data="list"
            class="m-t-24 hall-table"
            size="medium"
            :header-cell-style="{ fontSize: '22px', textAlign: 'left' }"
            align="left"
          >
            <el-table-column prop="supplierName" label="投标单位">
              <template v-slot:default="{ row }">
                <div class="row-content">{{ row.supplierName || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="一阶段评审">
              <template v-slot:default>
                <div class="row-content">通过</div>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-if="total > 0"
            :total="total"
            :page.sync="page"
            :limit.sync="size"
            :page-sizes="[5, 10]"
            @pagination="getTableData"
          />
        </div>
        <div class="end-step-table" :class="{ light: theme === 'light' }">
          <div class="end-step-table-title">
            一阶段评审不通过名单({{ rejectTotal }}家)
          </div>
          <el-table
            :data="rejectList"
            class="m-t-24 hall-table"
            size="medium"
            :header-cell-style="{ fontSize: '22px', textAlign: 'left' }"
            align="left"
          >
            <el-table-column prop="supplierName" label="投标单位">
              <template v-slot:default="{ row }">
                <div class="row-content">{{ row.supplierName || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="一阶段评审">
              <template v-slot:default>
                <div class="row-content">不通过</div>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-if="rejectTotal > 0"
            :total="rejectTotal"
            :page.sync="rejectPage"
            :limit.sync="rejectSize"
            :page-sizes="[5, 10]"
            @pagination="getRejectTableData"
          />
        </div>
      </template>

      <div v-else class="end-step" :class="{ light: theme === 'light' }">
        <img src="../../../assets/images/hall/open-bid-end.png" alt="" />
        <p v-if="isDouble && !isQuotationFile" class="m-t-24">
          一阶段开标结束, 专家评审中...
        </p>
        <p v-else class="m-t-24">开标结束</p>
      </div>
    </template>
  </bid-open-center>
</template>

<script>
import BidOpenCenter from '@/components/kpb/open/BidOpenCenter.vue'
import Pagination from '@/components/common/Pagination.vue'
import {
  bidFileTypeDict,
  reviewModelDict
} from '@/dictionary/project/kpb-project'
import {
  quoteOpenStatusDict,
  sortByTimeDict
} from '@/dictionary/hall/open-bid-hall'
import useFileDecrypt from '@/components/kpb/hooks/useFileDecrypt'
import { workbenchServiceDict } from '@/dictionary/system'
export default {
  name: 'OpenBidEnd',

  components: { BidOpenCenter, Pagination },

  props: {
    theme: {
      validator: function(value) {
        return ['dark', 'light'].indexOf(value) !== -1
      },
      default: 'dark'
    },

    projectId: {
      type: [String, Number],
      default: 0
    },

    projectInfo: {
      type: Object,
      default: () => {}
    },

    reviewModel: {
      type: Number,
      default: reviewModelDict.DEFAULT.value
    },

    bidFileType: {
      type: Number,
      default: bidFileTypeDict.BUSINESS.value
    },

    // 报价文件开标状态
    quoteOpenStatus: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      list: [],
      page: 1,
      size: 10,
      total: 0,

      rejectList: [],
      rejectPage: 1,
      rejectSize: 10,
      rejectTotal: 0
    }
  },

  computed: {
    isDouble() {
      return this.reviewModel === reviewModelDict.DOUBLE.value
    },

    isQuotationFile() {
      return this.bidFileType === bidFileTypeDict.QUOTATION.value
    },

    showFirstReviewPassTable() {
      return this.quoteOpenStatus >= quoteOpenStatusDict.PENDING.value
    }
  },

  watch: {
    quoteOpenStatus: {
      handler() {
        if (this.showFirstReviewPassTable) {
          this.getTableData()
          this.getRejectTableData()
        }
      },
      immediate: true
    }
  },

  methods: {
    getTableData() {
      const pageParams = {
        page: this.page,
        size: this.size,
        sortBy: sortByTimeDict.SUBMIT_TIME.value
      }
      const quoteFileService = useFileDecrypt(
        workbenchServiceDict.PURCHASER.alias,
        this.projectId,
        bidFileTypeDict.QUOTATION.value
      )
      quoteFileService
        .getQuoteEncryptFilePage(pageParams)
        .then(pageRes => {
          this.list = pageRes.records || []
          this.total = pageRes.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    getRejectTableData() {
      const pageParams = {
        page: this.page,
        size: this.size,
        sortBy: sortByTimeDict.SUBMIT_TIME.value,
        isWasteFile: true
      }
      const quoteFileService = useFileDecrypt(
        workbenchServiceDict.PURCHASER.alias,
        this.projectId,
        bidFileTypeDict.QUOTATION.value
      )
      quoteFileService
        .getQuoteEncryptFilePage(pageParams)
        .then(pageRes => {
          this.rejectList = pageRes.records || []
          this.rejectTotal = pageRes.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.end-step-table {
  width: 100%;

  .end-step-table-title {
    font-size: 22px;
    color: $white-color;
  }

  // 浅色主体下的样式修改
  &.light {
    .end-step-table-title {
      color: $text-color;
    }
    .hall-table {
      ::v-deep .el-table__empty-text {
        font-size: 20px;
        line-height: 80px;
      }
    }
  }

  // 表格
  .hall-table {
    .row-content {
      font-size: 22px;
      text-align: left;
      line-height: 1.5;
    }
  }
}

.end-step {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: calc(220px - 43px);

  &.light {
    p {
      color: $text-color;
    }
  }

  img {
    width: 160px;
  }

  p {
    color: #feffff;
    font-size: 24px;
  }
}
</style>
